<template>
  <span v-text="label"/>
</template>

<script>
import gases from '@/domain/enums/installation/engineering/chromatography/gases';

const labels = {
  [gases.H2]: 'H₂',
  [gases.CH4]: 'CH₄',
  [gases.C2H6]: 'C₂H₆',
  [gases.C2H4]: 'C₂H₄',
  [gases.C2H2]: 'C₂H₂',
  [gases.CO]: 'CO',
  [gases.CO2]: 'CO₂',
  [gases.N2]: 'N₂',
  [gases.O2]: 'O₂',
};

export default {
  props: {
    /**
     * Gas.
     * Um valor do enum de Gases
     * @see src\domain\enums\engineering\gases.js
     */
    value: String,
  },
  computed: {
    label() {
      const label = labels[this.value];

      if (label == null) {
        throw new Error(`Unknown gas label: ${this.value}`);
      }

      return label;
    },
  },
};
</script>
